import { FaUser } from "react-icons/fa";
import { Image, Transformation } from "cloudinary-react";
import { useMediaQuery } from "react-responsive";

export default function Profile({ collaborator, className }) {
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  return (
    <div className={className}>
      {collaborator.firstName && (
        <>
          <a href={collaborator.linkedin} target="_blank">
            {collaborator.photo ? (
              <Image
                cloudName="easycapital"
                alt={"Photo " + collaborator.firstName}
                publicId={collaborator.photo}
              >
                <Transformation
                  height={isDesktop ? "500" : "400"}
                  width={isDesktop ? "500" : "400"}
                  crop="fill"
                  gravity="face"
                  radius="100"
                />
              </Image>
            ) : (
              <FaUser />
            )}
            <p className="name">{collaborator.firstName + ' ' + collaborator.lastname}</p>
          </a>
          <a href={"tel:+33" + collaborator.phone}>{collaborator.phone}</a>
          <p>{collaborator.email}</p>
        </>
      )}
    </div>
  );
}
